import * as React from "react";
function SvgMenuCollapse(props) {
  return <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 4.333h12V3H2v1.333zm0 4.334h6.667V7.333H2v1.334zM14 13H2v-1.333h12V13zm-2.705-7a.333.333 0 00-.515.28v3.303c0 .265.293.424.515.28l2.553-1.652a.333.333 0 000-.56L11.295 6z" fill="#fff" /></svg>;
}
export default SvgMenuCollapse;